// removed by extract-text-webpack-plugin
module.exports = {"store":"ayPYc","header":"_1CB6q","brand":"E5AZr","avatar":"_2Q4Y6","name":"_35P5h","location":"iTwIJ","description":"_2QoVz","mapHeader":"_393Zq","collectionHeader":"_1FAGv","aboutCard":"_1-7Gh","stringCell":"_3ZEWM","iconCell":"_2A7X0","addressIcon":"_7Z24j","clockIcon":"UWA9X","phoneIcon":"r2gmO","urlIcon":"_1H4Ky","emailIcon":"_27xXH","mapContainer":"_1rQeU","mapLoadingContainer":"_2AskQ","collectionLinks":"_1ZoAu","collectionLink":"_38tLA"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/StoreAboutPage/index.sass
// module id = 1509
// module chunks = 1